import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const simulated = params.get("simulated") === "1";
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let t;
    const load = async () => {
      try {
        const { data } = await http.get(`/payments/status/${ref}`);
        setStatus(data);
      } catch (_e) { /* ignore */ } finally { setLoading(false); }
    };
    if (ref) {
      load();
      t = setInterval(load, 4000);
    }
    return () => clearInterval(t);
  }, [ref]);

  const paid = status?.payment_status === "paid";
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 text-white">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-[#0A1128] p-10 text-center">
        {loading ? <Clock className="w-16 h-16 mx-auto text-[#D4AF37]" /> :
          paid ? <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-400" /> :
          <Clock className="w-16 h-16 mx-auto text-[#D4AF37]" />
        }
        <h1 className="font-heading text-3xl mt-6">
          {paid ? "Payment received" : simulated ? "Booking created (demo)" : "Payment pending"}
        </h1>
        <p className="mt-3 text-white/65">
          {simulated ? "Mollie isn't configured yet — your booking is saved. Add a Mollie key in admin settings to enable live payments."
                     : `Reference: ${ref}`}
        </p>
        {status && (
          <div className="mt-6 text-sm text-white/70">
            Status: <span className="text-[#D4AF37]">{status.status}</span> · Payment: <span className="text-[#D4AF37]">{status.payment_status}</span>
            {status.total != null && <> · Total: <span className="text-[#D4AF37]">€{status.total?.toFixed(2)}</span></>}
          </div>
        )}
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/dashboard"><Button data-testid="goto-dashboard" className="bg-[#D4AF37] hover:bg-[#B5952F] text-[#040814]">My bookings</Button></Link>
          <Link to="/"><Button variant="ghost" className="border border-white/20">Home</Button></Link>
        </div>
      </div>
    </div>
  );
}
